import React from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { LOGO_URL } from "../lib/api";

export const Header = ({ minimal = false }) => (
    <header className="border-b border-ash-gray-light bg-white" data-testid="site-header">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
            <a
                href="https://ash-interactive.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="logo-link"
                className="flex items-center gap-3"
                aria-label="ASH Interactive — open ash-interactive.com in a new tab"
            >
                <img src={LOGO_URL} alt="ASH Interactive" className="h-9 w-auto" />
            </a>
            {!minimal && (
                <nav className="flex items-center gap-4 md:gap-6">
                    <Link
                        to="/"
                        data-testid="checkup-home-link"
                        className="hidden md:inline text-xs uppercase tracking-widest text-ash-gray-dark hover:text-ash-orange font-bold transition-colors"
                    >
                        Marketing Clarity Checkup
                    </Link>
                    <Link
                        to="/admin/login"
                        data-testid="header-login-link"
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-widest font-bold text-ash-black border border-ash-gray-light hover:border-ash-orange hover:text-ash-orange transition-colors px-3 py-2"
                        aria-label="Admin login"
                    >
                        <LogIn size={14} />
                        Login
                    </Link>
                </nav>
            )}
        </div>
    </header>
);

export const Footer = () => (
    <footer className="bg-ash-black text-white mt-20" data-testid="site-footer">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
                <div className="font-display text-xl font-bold">ASH Interactive</div>
                <div className="text-sm text-white/60 mt-1">
                    Strategy. Branding. Storytelling. Built for organizations that want to grow.
                </div>
            </div>
            <div className="text-sm text-white/60">info@ash-interactive.com</div>
        </div>
    </footer>
);

export const Layout = ({ children, minimal = false }) => (
    <div className="min-h-screen flex flex-col bg-ash-off-white">
        <Header minimal={minimal} />
        <main className="flex-1">{children}</main>
        <Footer />
    </div>
);
